
$(document).ready(function() {
    
  $(document).on('click', '.option-values', function() {
    var parentLi = $(this).closest('li,.collage__item--product');
    $(this).siblings().removeClass('selected');
    $(this).addClass('selected');
    updateStockAvailability(parentLi);
});

function updateStockAvailability(parentLi) {
    var selectedColor = parentLi.find('.variant-option--1 .option-values.selected').data('value') || null;
    var selectedSize = parentLi.find('.variant-option--2 .option-values.selected').data('value') || null;
    var selectedMaterial = parentLi.find('.variant-option--3 .option-values.selected').data('value') || null;

    parentLi.find('.option-values').removeClass('out-of-stock');

    var availableVariants = {};

    parentLi.find('.product-variants li').each(function () {
        var variantName = $(this).attr('data-title') || "";
        var variantQty = parseInt($(this).attr('data-quantity')) || 0;
        var variantId = $(this).attr('data-variant-id') || "";
        var variantImage = $(this).attr('data-variant-image') || "";
        var variantParts = variantName.split('-').map(part => part.trim()).filter(Boolean);
        var key = variantParts.join('-');

        availableVariants[key] = {
            inStock: variantQty > 0,
            variantId: variantId,
            variantQty: variantQty,
            variantImage: variantImage
        };
    });

    function createKey(...values) {
        return values.filter(Boolean).join('-');
    }

    var selectedVariantKey = createKey(selectedColor, selectedSize, selectedMaterial);
    var cartButton = parentLi.find('.card-information-cart-button');

    if (availableVariants[selectedVariantKey]) {
        var selectedVariant = availableVariants[selectedVariantKey];

        cartButton
            .attr('data-var-id', selectedVariant.variantId)
            .attr('data-var-qty', selectedVariant.variantQty);

        if (selectedVariant.variantQty > 0) {
            cartButton.removeClass('out-of-stock');
        } else {
            cartButton.addClass('out-of-stock');
        }

        if (selectedVariant.variantImage) {
            parentLi.find('.card__media img').attr('srcset', selectedVariant.variantImage);
            parentLi.find('.card__media img').attr('src', selectedVariant.variantImage);
        }
    } else {
        cartButton.addClass('out-of-stock'); // Agar selected variant nahi mila, toh button disable hoga
    }

    // **Fix out-of-stock detection**
    function checkStockAvailability(optionClass, selectedValues) {
        parentLi.find(optionClass + ' .option-values').each(function () {
            var value = $(this).data('value');
            var key = createKey(...selectedValues.map((v, i) => (i === selectedValues.indexOf(null) ? value : v)));
            if (!availableVariants[key] || availableVariants[key].variantQty <= 0) {
                $(this).addClass('out-of-stock');
            }
        });
    }

    checkStockAvailability('.variant-option--1', [null, selectedSize, selectedMaterial]);
    checkStockAvailability('.variant-option--2', [selectedColor, null, selectedMaterial]);
    checkStockAvailability('.variant-option--3', [selectedColor, selectedSize, null]);
}






setTimeout(function() {
    $('.veda-collection-inner-grid .product-options-wrapper').each(function() {
    if ($(this).find('p').length === 0) {
      $(this).hide(); 
    }
    });
}, 2000);


document.body.addEventListener("click", function (event) {
    let button = event.target.closest(".card-information-cart-button");
    
    if (button) {
        let loader = button.closest(".card").querySelector("span.card-product-loader .loader");
        if (loader) {
            loader.style.display = "inline-block"; 
        }

        let productId = button.getAttribute("data-var-id");
        let productQty = button.getAttribute("data-var-qty");
        let cartType = button.getAttribute("data-cart-type"); // Get the cart type

        if (productId && productQty) {
            productQty = parseInt(productQty);
            if (productQty > 0) {
                // Add to cart via fetch
                fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        quantity: 1,
                        id: parseInt(productId),
                    }),
                })
                .then(response => response.json())
                .then(() => {
                    // Update data-var-qty value (reduce by 1)
                    let newQty = productQty - 1;
                    button.setAttribute("data-var-qty", newQty);

                    // Check if the product is out of stock
                    if (newQty <= 0) {
                        button.setAttribute("disabled", "disabled");
                        button.classList.add("out-of-stock"); // Add out-of-stock class
                    }

                    if (cartType === "drawer") {
                        // If cart type is "drawer", load the drawer
                        return fetch("/cart", {
                            method: "GET",
                            headers: {
                                "Content-Type": "text/html",
                            },
                        })
                        .then(response => response.text())
                        .then(html => {
                            let parser = new DOMParser();
                            let doc = parser.parseFromString(html, "text/html");
                            let cartDrawerItems = document.querySelector("cart-drawer-items");
                            if (cartDrawerItems) {
                                cartDrawerItems.innerHTML = doc.querySelector("cart-drawer-items").innerHTML;
                            }
                            document.querySelector("cart-drawer").classList.add("active");
                            refreshCartDrawer();
                        });
                    } else if (cartType === "page") {
                        // If cart type is "page", redirect to the cart page
                        window.location.href = "/cart";
                    }
                })
                .finally(() => {
                    if (loader) {
                        loader.style.display = "none"; 
                    }
                })
                .catch(error => console.error("Error:", error));
            } else {
                button.setAttribute("disabled", "disabled");
                button.classList.add("out-of-stock"); // Add out-of-stock class when initially 0
                if (loader) {
                    loader.style.display = "none"; 
                }
            }
        } else {
            console.error("Missing data-var-id or data-var-qty on button!");
            if (loader) {
                loader.style.display = "none"; 
            }
        }
    }
    
    // Update cart count
    $.getJSON('/cart.js', function(cart) {
        setTimeout(function() {
            $('.cart-count-bubble span[aria-hidden="true"]').text(cart.item_count);
        }, 600);
    });
  

});












function refreshCartDrawer() {
  let cartDrawerItems = document.querySelector("cart-drawer-items");
  const cartDrawer = document.querySelector("cart-drawer");
  const cartDrawerCheckout = document.querySelector(".cart__checkout-button"); // Ensure correct selector

  if (cartDrawer) {
    if (cartDrawer.classList.contains("is-empty")) {
      cartDrawer.classList.remove("is-empty");
    }
      cartDrawerCheckout.removeAttribute("disabled");

    const emptyDrawerElement = cartDrawer.querySelector(".drawer__inner-empty");
    if (emptyDrawerElement) {
      emptyDrawerElement.remove();
    }

    const cartContentsForm = document.querySelector(".cart__contents");
    if (cartContentsForm) {
      cartContentsForm.style.display = "block";
    }
  }

  if (!cartDrawerItems) {
    cartDrawerItems = document.createElement("cart-drawer-items");
    const drawerHeader = document.querySelector(".drawer__header");
    if (drawerHeader) {
      drawerHeader.insertAdjacentElement("afterend", cartDrawerItems);
    }
  }

  const cartItemsComponent = document.querySelector("cart-drawer-items");
  if (cartItemsComponent && typeof cartItemsComponent.onCartUpdate === "function") {
    cartItemsComponent.onCartUpdate();
  }

  if (cartDrawer && typeof cartDrawer.open === "function") {
    cartDrawer.open();
  }
  
}
  
});